export const timeline = {
  _root: "/timeline",
  event: {
    _root: "/event/:id"
  },
  createEvent: "/create-event"
};
